import { Id } from "./id";
import { z } from "zod";
export const ForgeProjectSectionChildType = z.enum(["Artifact", "Feature"]);
export const SortOrder = z.number().int();
export const ForgeSection = z.object({
    id: Id,
    projectId: z.string(),
    name: z.string(),
    sortOrder: SortOrder.default(0),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    childType: ForgeProjectSectionChildType,
});
